import * as React from "react";
import {
  useTheme,
  Stack,
  Typography,
  Drawer,
  Box,
  useMediaQuery,
} from "@mui/material";
import { Menu, WhatsApp } from "@mui/icons-material";
import SideMenu from "./SideMenu";

const NavBar = ({}) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const theme = useTheme();

  const toggleDrawer = (openStatus) => {
    setDrawerOpen(openStatus);
  };

  const smallScreen = useMediaQuery(theme.breakpoints.down(1000));

  return (
    <Stack
      sx={{
        bgcolor: `rgba(0,0,0,.8)`,
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
        zIndex: 900,
      }}
    >
      <Stack
        direction={"row"}
        sx={{
          background: "blur(1.5rem)",
          height: "100px",
          alignItems: "center",
          justifyContent: "space-between",
          px: "1.5rem",
          backdropFilter: "blur(10px) saturate(30%)",
        }}
      >
        <Stack
          sx={{
            p: "0.5rem",
            bgcolor: theme.palette.common.white,
            borderRadius: "50%",
            overflow: "hidden",
          }}
        >
          <Menu
            onClick={() => {
              toggleDrawer(true);
            }}
            sx={{
              transition: "all .3s",
              color: theme.palette.common.black,
              fontSize: "22px",
              transform: "rotate(0deg)",
              "&:hover": {
                transition: "all .3s",
                cursor: "pointer",
                transform: "rotate(180deg)",
              },
            }}
          />
        </Stack>
        <Drawer
          anchor={"left"}
          open={drawerOpen}
          onClose={() => {
            toggleDrawer(false);
          }}
          sx={{}}
        >
          <Stack
            sx={{
              height: "100%",
              minWidth: "230px",
              width: "230px",
              bgcolor: theme.palette.common.white,
              overflow: "auto",
            }}
          >
            <SideMenu />
          </Stack>
        </Drawer>
        <a
          href="https://wa.me/+243896541721"
          style={{
            textDecoration: "none",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.whiteColor.main,
              fontSize: "14px",
              fontWeight: theme.typography.fontWeightRegular,
              mr: "1rem",
            }}
          >
            Whatsapp me now
          </Typography>
          <Stack
            sx={{
              p: "0.5rem",
              bgcolor: theme.palette.common.white,
              borderRadius: "50%",
              overflow: "hidden",
            }}
          >
            <WhatsApp
              sx={{
                fontSize: "22px",
                color: theme.palette.whatsapp.main,
                transition: "all .3s",
                transform: "rotate(0deg)",
                "&:hover": {
                  transition: "all .3s",
                  cursor: "pointer",
                  transform: "rotate(360deg)",
                },
              }}
            />
          </Stack>
        </a>
      </Stack>
    </Stack>
  );
};

export default NavBar;
